import { baseApi } from "./baseApi";

const loanLiabilitiesApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getLoanLiabilities: builder.query({
      query: (loanId) => ({
        url: `/loans/${loanId}/liabilities`,
        method: "GET",
      }),
      providesTags: (result, error, loanId) => [
        { type: "LoanLiabilities", id: loanId },
      ],
    }),
    createLoanLiability: builder.mutation({
      query: ({ loanId, body }) => ({
        url: `/loans/${loanId}/liabilities`,
        method: "POST",
        body,
      }),
      invalidatesTags: (result, error, { loanId }) => [
        { type: "LoanLiabilities", id: loanId },
        { type: "Loan", id: loanId },
      ],
    }),
    updateLoanLiability: builder.mutation({
      query: ({ loanId, liabilityId, body }) => ({
        url: `/loans/${loanId}/liabilities/${liabilityId}`,
        method: "PUT",
        body,
      }),
      invalidatesTags: (result, error, { loanId }) => [
        { type: "LoanLiabilities", id: loanId },
        { type: "Loan", id: loanId },
      ],
    }),
    deleteLoanLiability: builder.mutation({
      query: ({ loanId, liabilityId }) => ({
        url: `/loans/${loanId}/liabilities/${liabilityId}`,
        method: "DELETE",
      }),
      invalidatesTags: (result, error, { loanId }) => [
        { type: "LoanLiabilities", id: loanId },
        { type: "Loan", id: loanId },
      ],
    }),
  }),
});

export default loanLiabilitiesApi;
